'use client';
import { useEffect } from 'react';

export function HtmlLangClient({ locale }: { locale: string }) {
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);
  return null;
}
